import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

let mutations = {
  cutModuleState(state, config) {
    // 组件切换
    state.moduleState[config.name] = config.b;
    if (config.name === 'editStory' && config.b) {
      state.hideEditStory = false;
    }
    config.call && config.call.call(config.caller);
  },

  initCreateRoleConfig() {
    return {
      isChange: false,
      id: null,
      name: '',
      desc: '',
      gender: '',
      pic: '',
      coverName: null,
      coverNameFull: null,
      coverNameRs: null
    }
  },
  initStateCreateRole() {
    state.createRole = state.mutations.initCreateRoleConfig();
  },
  editStorySetout() {
    // 获取章节列表
    state.chapterList = Middle.ProjectData.chapter._values;

    if (Middle.EditData) {
      // 获取当前编辑的章节
      state.editChapter = Middle.EditData.chapter;
    }
    // 获取故事简介
    state.storyName = Middle.ProjectData.header.name;
    state.storyDesc = Middle.ProjectData.header.description;
    // 获取角色列表
    state.storyRoles = Middle.ProjectData.character._values;

    // 获取作品封面
    var cover = Middle.ProjectData.header.cover, coverRes = null;

    if (cover) {
      coverRes = cover;
    } else {
      coverRes = state.defCover;
      Middle.ProjectData.header.cover = coverRes;
    }

    state.storyCover = coverRes;
    state.vagueChapterName = '';
    state.isAddjump = false;
  }
};

let state = {
  numericalEditData: null,
  numericalType: 'add',
  numericalSwitch: false,
  conditionsType: 'add',
  conditionsSwitch: false,
  adjustmentItems: null,
  defCover: location.protocol + '//pic.cgyouxi.com/demo/title/dbd0d65c30500cf25911e9eee1750758_1.jpg',
  aBoxCoverLoading: false,
  publishLoading: false,
  viewHeight: '',
  vagueChapterName: '',
  manID: null,
  womanID: null,
  watchHasMainRole: false,
  autoSaveTimer: null,
  sendMesCount: 0,
  mutations: mutations,
  addChapterType: null,
  editText: false,
  nameReg: /\*|\?|\:|\"|\<|\>|\/|\\|\|/ig,
  emoReg: /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/ig,
  guide: false,
  closeEditStory: false,
  hideEditStory: false,
  MaLimit: 20,
  roleHeadFlag: '_f_0',
  roleThoraxFlag: '_w_0',
  changeChapterMedia: false,
  nextPageHeaderConf: {
    editStory: null,
    pattern: null,
    creation: null,
    chapterSet: null,
    editStoryRole: null,
    createRole: null,
    maLib: null,
    maLibPreview: null,
    roleList: null,
    editStoryText: {
      backNote: '返回',
      backPage: 'editStory'
    },
    editText: null
  },
  backPage: '',
  visualEdit: false,
  hideStoryInput: false,
  emojiLists: [],
  myStorys: [],
  myStorysLength: null,
  categoryMapper: {
    nowCategory: {},
    bgImg: {}
  },
  storyCover: null,
  setRoleSiteDom: false,
  isShortcutInit: false,
  editMsgText: '',
  editMsgEmoji: false,
  storyStyle: '',
  roleSite: -1,
  storyName: '',
  storyDesc: '',
  editChapter: '',
  useRole: {
        cover: null, name: "", mood: 'normal'
  },
  openMaLibAffair: '',
  openMaLibCallBack: null,
  storyRoles: [],
  stageRoles: {
    status: '',
    main: [],
    costar: []
  },
  chapterSet: {
    bgSrc: '',
    bgName: '',
    musicSrc: '',
    musicName: ''
  },
  chapterConfig: {
    bg: null,
    bgm: null
  },
  chapterList: [],
  moodList: [
    {src: '../../static/image/mood_0_1.png', type: 'normal', name: '正常'},
    {src: '../../static/image/mood_1_1.png', type: 'happy', name: '喜'},
    {src: '../../static/image/mood_2_1.png', type: 'sad', name: '怒'},
    {src: '../../static/image/mood_3_1.png', type: 'angry', name: '哀'}
  ],
  parrent: {
    types: [
      {pic: '../../static/image/swiper1.png', modeIcon: '../../static/image/mode1.png', name: '对话故事'},
      {pic: '../../static/image/swiper2.png', modeIcon: '../../static/image/mode2.png', name: '视觉故事'},
      {pic: '../../static/image/swiper3.png', modeIcon: '../../static/image/mode3.png', name: '视觉故事'}
    ],
    createType: 'ks',
    createPattern: '',
    useModal: '',
    style: ''
  },
  defaultRolePic: {
    man_1: [
      "13597_温润儒雅公子_f_0.png",
      "13597_温润儒雅公子_h_0.png",
      "13597_温润儒雅公子_h_1.png",
      "13597_温润儒雅公子_h_2.png",
      "13597_温润儒雅公子_h_3.png",
      "13597_温润儒雅公子_w_0.png"
    ],
    woman_1: [
      "18776_吃货女_五套衣服_f_0.png",
      "18776_吃货女_五套衣服_h_0.png",
      "18776_吃货女_五套衣服_h_1.png",
      "18776_吃货女_五套衣服_h_2.png",
      "18776_吃货女_五套衣服_h_3.png",
      "18776_吃货女_五套衣服_w_0.png"
    ],
    man_0: [
      "24791_阳光大男孩_f_0.png",
      "24791_阳光大男孩_h_0.png",
      "24791_阳光大男孩_h_1.png",
      "24791_阳光大男孩_h_2.png",
      "24791_阳光大男孩_h_3.png",
      "24791_阳光大男孩_w_0.png"
    ],
    woman_0: [
      "10760_女学生_f_0.png",
      "10760_女学生_h_0.png",
      "10760_女学生_h_1.png",
      "10760_女学生_h_2.png",
      "10760_女学生_h_3.png",
      "10760_女学生_w_0.png"
    ]
  },
  defaultRolePicToCanvas: {
    man_1: [
      "13597_温润儒雅公子_f_0.png",
      "half/13597_温润儒雅公子_h_0.png",
      "half/13597_温润儒雅公子_h_1.png",
      "half/13597_温润儒雅公子_h_2.png",
      "half/13597_温润儒雅公子_h_3.png",
      "half/13597_温润儒雅公子_w_0.png"
    ],
    woman_1: [
      "18776_吃货女_五套衣服_f_0.png",
      "half/18776_吃货女_五套衣服_h_0.png",
      "half/18776_吃货女_五套衣服_h_1.png",
      "half/18776_吃货女_五套衣服_h_2.png",
      "half/18776_吃货女_五套衣服_h_3.png",
      "half/18776_吃货女_五套衣服_w_0.png"
    ],
    man_0: [
      "24791_阳光大男孩_f_0.png",
      "half/24791_阳光大男孩_h_0.png",
      "half/24791_阳光大男孩_h_1.png",
      "half/24791_阳光大男孩_h_2.png",
      "half/24791_阳光大男孩_h_3.png",
      "half/24791_阳光大男孩_w_0.png"
    ],
    woman_0: [
      "10760_女学生_f_0.png",
      "half/10760_女学生_h_0.png",
      "half/10760_女学生_h_1.png",
      "half/10760_女学生_h_2.png",
      "half/10760_女学生_h_3.png",
      "half/10760_女学生_w_0.png"
    ]
  },
  createRole: mutations.initCreateRoleConfig(),
  moduleState: {
    start: true,
    isAddjump: false,
    pattern: false,
    storyMenu: false,
    storysList: true,
    creationType: false,
    chapterList: false,
    editStory: false,
    editStoryRole: false,
    createRole: false,
    rolePicMaterial: false,
    chapterset: false,
    changeChapter: false,
    roleList: false,
    issueSuccess: false,
    imageLibrary: false,
    musicLibrary: false,
    createStoryWin: false,
    imageLibraryPreview: false,
    editStoryText: false,
    isStoryLoading: false,
    autoSave: false,
    editText: false,
    adjustmentPopup: false,
    addTag: false
  },
  isChangeChapter: false,
  isAddChapter: false,
  datas: {
    creationType: {
      btnType: ['现代', '古代'],
      baseTypes: [
        {title: '快速创作', explain: '（适合新手）', intro: '我们会为您创建一套故事模板，帮您熟悉制作', btnType: ['现代', '古代']},
        {title: '普通创作', explain: '（适合老手）', intro: '请按照您的创作需要，自由创建，自由发挥', btnType: ['现代', '古代']}
      ],
      style: ''
    },
    nowEditStory: {
      name: '',
      chapter: ''
    },
    defaultRolePic: '../../static/image/role_pic.png',
    newStoryCreateRole: [],
    alterRoleDetail: {
      name: '',
      desc: '',
      pic: ''
    },
    storys: [],
    editOldStory: {
      b: false,
      i: 0
    },
    changeRoleDetail: {
      status: false,
      i: 0
    },
    // guideDispose: {},
  },
  guideConf: {
    length: 5,
    editNote: false,
    isShow: false,
    nowProgress: 1,
    dispose: {
      step1: false,
      step2: false,
      step3: false,
      step4: false,
      step5: false,
      step6: false
    },
    record: {
      step5: false
    },
    toolY: 0
  }
};

export default new Vuex.Store({
  mutations,
  state
})



// WEBPACK FOOTER //
// ./src/store/store.js